module.exports = __webpack_public_path__ + "static/media/steam-press-service.9f4cb0c1.webp";